import React from "react";
import { MapPin, Layers, Cpu, Landmark, FileCheck2, Hammer } from "lucide-react";

const REASONS = [
  {
    icon: MapPin,
    title: "Saudi market insight",
    body: "Deep on-ground context for Vision 2030 opportunities across sectors.",
  },
  {
    icon: Layers,
    title: "Strategic + technical thinking",
    body: "Advisory grounded in engineering, economics and executable delivery.",
  },
  {
    icon: Cpu,
    title: "Technology partner ecosystem",
    body: "Access to vetted OEMs and global technology partners.",
  },
  {
    icon: Landmark,
    title: "Localization-focused approach",
    body: "Local content, joint ventures and factory setup built into strategy.",
  },
  {
    icon: FileCheck2,
    title: "Investor-ready documentation",
    body: "Feasibility, financial models and pitch materials that hold up.",
  },
  {
    icon: Hammer,
    title: "Practical execution mindset",
    body: "Coordination and integration support until value is delivered.",
  },
];

export default function WhyUs() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative bg-white py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-6">
            <div className="overline mb-5">Why TAQAVED</div>
            <h2 className="font-display text-4xl md:text-5xl font-medium text-[#0A1128] tracking-tight leading-[1.05]">
              Built for investable,
              <br />
              <span className="italic text-[#059669]">executable</span> outcomes.
            </h2>
          </div>
          <div className="lg:col-span-6 flex items-end">
            <p className="text-lg text-slate-600 max-w-xl">
              We combine market intelligence, technology access and delivery discipline — so
              boards, investors and partners can move with confidence.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {REASONS.map((r, i) => {
            const Icon = r.icon;
            return (
              <div
                key={i}
                data-testid={`why-item-${i}`}
                className="relative rounded-2xl border border-slate-200 p-8 bg-white card-lift"
              >
                <div className="flex items-start justify-between">
                  <div className="w-11 h-11 rounded-xl bg-[#059669]/10 flex items-center justify-center">
                    <Icon className="w-5 h-5 text-[#059669]" />
                  </div>
                  <span className="text-xs font-semibold tracking-widest text-slate-300">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="mt-8 font-display text-xl md:text-2xl font-medium text-[#0A1128] tracking-tight leading-tight">
                  {r.title}
                </h3>
                <p className="mt-3 text-slate-600 text-[15px] leading-relaxed">{r.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
